let config = {
    authFrontHost: "infini.tools",
    apiHost: "infini.tools",
    baseHost: "nutri.ketlen.com.br"
};

export default config;
